import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=3e672e0c&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e672e0c",
  null
  
)

export default component.exports